import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import Content from '../components/AuthContent';
import Header from '../components/AuthHeader';
import Footer from '../components/Footer';
export default {
  __name: 'Auth',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(Header)), _createVNode(_unref(Content)), _createVNode(_unref(Footer))], 64);
    };
  }
};